import { render, staticRenderFns } from "./cv-radio-group.vue?vue&type=template&id=85714a58&"
import script from "./cv-radio-group.vue?vue&type=script&lang=js&"
export * from "./cv-radio-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports